// export type PolychainError = TransactionError | WalletError

export class PolychainError extends Error {
  constructor(message: string, name: string, options?: ErrorOptions) {
    super(message, options)
    this.name = name
  }
}

export class TransactionError extends PolychainError {
  constructor(message: string) {
    super(message, "TransactionError")
    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, TransactionError)
    }
  }
}

export class OutOfGasError extends TransactionError {
  constructor() {
    super("Transaction failed due to insufficient gas.")
    this.name = "OutOfGasError"
    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, OutOfGasError)
    }
  }
}

export class InsufficientFundsError extends TransactionError {
  constructor() {
    super("Insufficient Funds")
    this.name = "InsufficientFundsError"
  }
}

export class TransactionRevertedError extends TransactionError {
  constructor(error: Error) {
    super("Wallet error occurred. Please refresh the page and try again.")
    this.name = "TransactionRevertedError"
    this.stack = error.stack
    this.cause = error
  }
}

export class WalletError extends PolychainError {
  constructor(message: string, options?: ErrorOptions) {
    super(message, "WalletError", options)
    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, WalletError)
    }
  }
}

export class WalletRejectedError extends WalletError {
  constructor(error: Error) {
    super("Rejected")
    this.name = "WalletRejectedError"
    this.cause = error
  }
}

export class SignatureError extends WalletError {
  constructor(error: Error) {
    super("Wallet error occurred. Please refresh the page and try again.")
    this.name = "SignatureError"
    this.cause = error
  }
}

export class SwitchChainError extends WalletError {
  constructor(error: Error) {
    super(
      "Failed to change network automatically. Please change network in your wallet and retry.",
    )
    this.name = "SwitchChainError"
    this.cause = error
  }
}

export class ConnectorChainMismatchError extends WalletError {
  constructor(error: Error) {
    super("Wallet error occurred. Please refresh the page and try again.")
    this.name = "ConnectorChainMismatchError"
    this.cause = error
  }
}

export class InternalWalletError extends WalletError {
  constructor(error: Error) {
    super("Wallet error occurred. Please refresh the page and try again.")
    this.name = "InternalWalletError"
    this.cause = error
  }
}

export class UnknownRpcError extends WalletError {
  constructor(error: Error) {
    super("Wallet error occurred. Please refresh the page and try again.")
    this.name = "UnknownRpcError"
    this.cause = error
  }
}

export class LedgerError extends WalletError {
  constructor(error: Error) {
    super("Ledger error occurred. Please try again.")
    this.name = "LedgerError"
    this.cause = error
  }
}

export class RequestExpiredError extends WalletError {
  constructor(error: Error) {
    super("Request expired. Please try again.")
    this.name = "RequestExpiredError"
    this.cause = error
  }
}

export class TransactionTimedOutError extends WalletError {
  constructor(error: Error) {
    super("Transaction timed out. Please try again.")
    this.name = "TransactionTimedOutError"
    this.cause = error
  }
}

export class IncompatibleActionError extends WalletError {
  constructor(error: Error) {
    super("Incompatible action")
    this.name = "IncompatibleActionError"
    this.cause = error
  }
}

export class AccountNotConnectedError extends WalletError {
  constructor(message: string) {
    super(message)
    this.name = "AccountNotConnectedError"
  }
}
